import "react-phone-number-input/style.css";

import CheckBox from "./CheckBox";
import PhoneInput from "react-phone-number-input";
import PropTypes from "prop-types";
import React from "react";
import eyeClosed from "assets/icons/eyeClosed.svg";
import eyeIcon from "assets/icons/eye.svg";
import { forwardRef } from "react";
import styled from "styled-components";
import { useEffect } from "react";
import { useField } from "formik";
import { useMemo } from "react";
import { useState } from "react";

export const FormGroupWrapper = styled.div`
  .fieldWrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    border-radius: 8px;
    height: ${(props) => (props.fieldStyle === "longText" ? "auto" : "4.8rem")};
    border: 1px solid var(--grey_10);
    position: relative;
    padding: 0 1.5rem;

    &.error {
      border-color: var(--danger);
    }
  }

  input,
  textarea,
  select {
    display: block;
    color: ${(props) => props.color ?? "var(--grey_1)"};
    width: 100%;
    height: 100%;
    background-color: transparent;
    border: none;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;

    &::placeholder {
      color: var(--grey_9);
    }
  }

  select {
    cursor: pointer;
    color: #6e7191;
  }

  .toggleShow {
    display: none;
  }

  &.password {
    input,
    textarea {
      width: 80%;
    }

    .toggleShow {
      display: inline;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: 1.5rem;
      height: 2rem;
    }
  }

  textarea {
    height: 14.4rem;
    padding: 1.5rem 0;
    line-height: 20px;
  }

  .dropdownIcon {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 1.5rem;
    pointer-events: none;
  }

  .errorText {
    display: block;
    width: 100%;
    text-align: left;
    margin-top: 0.6rem;
  }
`;

export const FormGroupLabel = styled.label`
  display: block;
  color: var(--body_text);
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;
  margin-bottom: 0.3rem;
  text-align: left;

  sup {
    color: var(--danger);
  }
`;

const CheckboxField = styled.div``;

const handleToggleShowPassword = (id) => {
  const field = document.querySelector(`#${id}`);

  if (field.type === "password") {
    field.type = "text";
  } else {
    field.type = "password";
  }
};

const handleCheckboxSelect = (e, id) => {
  e.preventDefault();

  const selectedElCheckbox = document.querySelector(`#${id}`);
  selectedElCheckbox.click();
};

const FormGroup = ({
  className,
  fieldStyle,
  type = "text",
  name,
  value,
  label,
  placeholder,
  required = true,
  defaultValue,
  color,
  onChange,
  rowIndex,
  phoneInput,
  ...props
}) => {
  const [field, meta] = useField({ ...props, name });
  const [showPassword, setShowPassword] = useState(false);
  const [phoneVal, setPhoneVal] = useState(field.value);

  if (typeof value === "string") field.value = value;

  const CustomPhoneInput = forwardRef(({ value, onChange, onBlur }, ref) => (
    <input
      style={{ paddingLeft: "0.6rem" }}
      ref={ref}
      {...field}
      className="textSmall"
      id={name}
      name={name}
      placeholder={placeholder}
      value={value}
      required={required || false}
      onBlur={(e) => {
        field.onBlur(e);
        onBlur(e);
      }}
      onChange={(e) => {
        field.onChange(e);
        onChange(e);
      }}
      {...props}
      autoComplete="off"
    />
  ));

  // eslint-disable-next-line
  const __CustomPhoneInput = useMemo(() => CustomPhoneInput, []);

  useEffect(() => {
    document.querySelectorAll(`input`).forEach((input) => {
      input.addEventListener("mousewheel", function (e) {
        e.target.blur();
      });
    });
    // eslint-disable-next-line
  }, []);

  if (type === "checkbox") {
    return (
      <CheckboxField className={`flex-row align-center ${className ?? ""}`}>
        <CheckBox className="checkbox" id={name} name={name} />
        <FormGroupLabel
          className="cursorPointer"
          htmlFor={name}
          onClick={(e) => handleCheckboxSelect(e, name)}
          style={{ marginBottom: 0, marginLeft: "0.5rem" }}
        >
          {label}
        </FormGroupLabel>
      </CheckboxField>
    );
  }

  return (
    <>
      <FormGroupWrapper className={className} fieldStyle={fieldStyle}>
        {label && (
          <FormGroupLabel htmlFor={name}>
            {label}
            {required && <sup>*</sup>}
          </FormGroupLabel>
        )}
        <div
          className={`fieldWrapper${meta.error ? " error" : ""}${
            phoneInput ? "  phoneInput" : ""
          }`}
        >
          {fieldStyle === "shortText" &&
            (phoneInput ? (
              <PhoneInput
                defaultCountry="NG"
                inputComponent={__CustomPhoneInput}
                value={phoneVal}
                onChange={setPhoneVal}
                international
              />
            ) : (
              <>
                <input
                  {...field}
                  className="textSmall"
                  id={name}
                  type={type}
                  defaultValue={defaultValue}
                  placeholder={placeholder}
                  onChange={(e) => {
                    onChange && onChange(rowIndex, name, e.target.value);
                    field.onChange(e);
                  }}
                  {...props}
                  autoComplete="off"
                />
                {type === "password" && (
                  <img
                    src={showPassword ? eyeClosed : eyeIcon}
                    alt="eye"
                    className="toggleShow cursorPointer"
                    onClick={(e) => {
                      setShowPassword((prev) => !prev);
                      handleToggleShowPassword(name);
                    }}
                  />
                )}
              </>
            ))}
          {fieldStyle === "longText" && (
            <>
              <textarea
                className="textSmall"
                id={name}
                name={name}
                required={required}
                defaultValue={defaultValue}
                placeholder={placeholder}
                {...field}
                {...props}
                autoComplete="off"
              />
            </>
          )}
        </div>
        {meta.error && (
          <span className="textDescription colorDanger errorText">
            {meta.error}
          </span>
        )}
      </FormGroupWrapper>
    </>
  );
};

FormGroup.propTypes = {
  className: PropTypes.string,
  fieldStyle: PropTypes.string.isRequired,
  type: PropTypes.string,
  name: PropTypes.string.isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  color: PropTypes.string,
  rowIndex: PropTypes.number,
};

export default FormGroup;
